import styled from 'styled-components';
import { Drawer, Tag } from 'antd';

export const SignalTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  .signal-drawer-title {
    margin-left: 10px;
    margin-right: 10px;
  }

  sup {
    color: #999;
  }
`;

export const ManageFooter = styled.div`
  display: flex;
  gap: 10px;
`;

export const StyledDrawer = styled(Drawer)`
  .ant-drawer-close {
    height: auto;
    width: auto;
    position: relative;
  }

  .ant-drawer-body {
    padding: 15px;
    overflow: hidden;
    display: flex !important;
    flex-direction: column;
    height: 100%;
    min-height: 0;
  }

  .ant-card-meta-title {
    font-weight: 400;
    font-size: 12px;
    white-space: wrap;
  }
`;

export const SignalBox = styled.div<{ $isSelected: boolean }>`
  cursor: pointer;
  border: 1px solid ${({ $isSelected }) => ($isSelected ? '#0958d9' : '#eee')};
  border-radius: 8px;
  margin: 10px 5px;
  padding: 12px 16px;
  background-color: ${({ $isSelected }) => ($isSelected ? 'rgb(24 144 255 / 4%)' : '#fff')};
  transition: all 0.2s;

  &:hover {
    border-color: ${({ $isSelected }) => ($isSelected ? '#0958d9' : '#40a9ff')};
    background-color: ${({ $isSelected }) =>
      $isSelected ? 'rgb(24 144 255 / 8%)' : 'rgb(24 144 255 / 2%)'};
  }
`;

export const StyledBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const SignalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const SignalName = styled.div`
  font-weight: 500;
  font-size: 14px;
  color: #262626;
`;

export const SignalMainPanel = styled.div`
  overflow-y: auto;
  flex: 1;
  min-height: 0;
`;

export const SectionHeader = styled.div`
  font-weight: 500;
  font-size: 12px;
  color: #8c8c8c;
  margin-bottom: 8px;
`;

export const StyledCheckableTag = styled(Tag.CheckableTag)<{ $checked: boolean }>`
  border-radius: 16px;
  border: 1px solid ${({ $checked }) => ($checked ? '#0958d9' : '#d9d9d9')};
  background-color: ${({ $checked }) => ($checked ? 'rgb(24 144 255 / 10%)' : '#fafafa')};
  color: ${({ $checked }) => ($checked ? '#0958d9' : '#595959')};
  cursor: pointer;

  &:hover {
    border-color: #40a9ff;
    background-color: ${({ $checked }) =>
      $checked ? 'rgb(24 144 255 / 15%)' : 'rgb(24 144 255 / 5%)'};
  }
`;

export const EmptyState = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px;
  color: #8c8c8c;
  font-size: 14px;
`;

export const DrawerCardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
`;
